import Loadable from "react-loadable";

export const ConnectInvestorModal = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.ConnectInvestorModal) as Promise<any>,
  loading: () => null,
});
